/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-undef */
/* eslint-disable no-lonely-if */
/* eslint-disable no-empty */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-plusplus */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './css/NightsPopover.css';
import {
  setNightsFrom,
  setNightsTo,
  selectionNightsFrom,
  selectionNightsTo,
} from '../../../DataStore/actions/searchFormActions';

const mapStateToProps = (state) => ({ ...state });

class NightsPopover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      firstClick: props.nightsFrom,
      selectedFrom: props.nightsFrom,
      selectedTo: props.nightsTo,
      twoDatesSelected: true,
    };
  }

  handleClick = (day) => {
    const {
      setNightsFrom: setNightsFromAction,
      setNightsTo: setNightsToAction,
      nightsButton,
    } = this.props;

    const { selectedFrom, selectedTo, twoDatesSelected } = this.state;

    if (twoDatesSelected) {
      this.setState({
        selectedFrom: day,
        selectedTo: day,
        firstClick: day,
        twoDatesSelected: false,
      });
    } else {
      this.setState({ twoDatesSelected: true });

      setNightsFromAction(selectedFrom);
      setNightsToAction(selectedTo);

      if (nightsButton) {
        nightsButton.click();
      }
    }
  };

  getClass = (day) => {
    const { selectedFrom, selectedTo } = this.state;

    if (day === selectedFrom) {
      if (selectedTo && selectedFrom !== selectedTo) {
        return 'sf__nights_popover_selected_from';
      }
      return 'sf__nights_popover_selected_single';
    } else if (day > selectedFrom && day < selectedTo) {
      return 'sf__nights_popover_selected_interval';
    } else if (day === selectedTo) {
      return 'sf__nights_popover_selected_to';
    } else {
      return '';
    }
  };

  onButtonHover = (day) => {
    const { selectedFrom, firstClick, twoDatesSelected } = this.state;

    if (!twoDatesSelected) {
      if (day >= selectedFrom) {
        if (day - selectedFrom <= 10) {
          this.setState({ selectedFrom: firstClick, selectedTo: day });
        }
      } else {
        if (firstClick - day <= 10) {
          this.setState({ selectedFrom: day, selectedTo: firstClick });
        }
      }
    }
  };

  renderButton = (start, end) => {
    const result = [];

    for (let day = start; day <= end; day++) {
      result.push(
        <button
          key={day}
          type="button"
          className={`bm_text_18 sf__nights_popover_day_item ${this.getClass(
            day,
          )}`}
          onClick={() => {
            this.handleClick(day);
          }}
          onMouseOver={() => this.onButtonHover(day)}
        >
          {day}
        </button>,
      );
    }

    return result;
  };

  render() {
    return (
      <div className="sf_nighs_popover_w">
        <div className="sf__nights_popover_line">{this.renderButton(1, 7)}</div>
        <div className="sf__nights_popover_line">
          {this.renderButton(8, 14)}
        </div>
        <div className="sf__nights_popover_line">
          {this.renderButton(15, 21)}
        </div>
        <div className="sf__nights_popover_line">
          {this.renderButton(22, 28)}
        </div>
      </div>
    );
  }
}

NightsPopover.propTypes = {
  nightsFrom: PropTypes.number.isRequired,
  setNightsFrom: PropTypes.func.isRequired,
  setNightsTo: PropTypes.func.isRequired,
  nightsTo: PropTypes.number.isRequired,
  nightsButton: PropTypes.instanceOf(Object).isRequired,
};

export default connect(mapStateToProps, {
  setNightsFrom,
  setNightsTo,
  selectionNightsFrom,
  selectionNightsTo,
})(NightsPopover);
